export default {
  downloadURL(state) {
    return state.downloadURL;
  },
  certificationDownloadURL(state) {
    return state.certificationDownloadURL;
  },
};
